export default __webpack_public_path__ + "static/media/nopicture.bc64060a.png";